import React, {PropsWithChildren} from 'react';
import {Header} from '../navigation/header';
import {Footer} from '../navigation/footer';
import {Container} from './Container';
import 'normalize.css/normalize.css';
import '../../css/layout.css';
import type {SlugLocale} from '../../types/locale';
import {config} from '@fortawesome/fontawesome-svg-core';
import {ParallaxProvider} from 'react-scroll-parallax';
// needed to get proper SSR styling: https://github.com/FortAwesome/react-fontawesome#nextjs
import '@fortawesome/fontawesome-svg-core/styles.css';
import {ExtendedBlogCategories} from '../../types/blogCategories';
import {HeaderWithoutNavigation} from '../navigation/header/HeaderWithoutNavigation';
import '../../css/gatsbyImageFix.css';
import {CookieConsentBanner} from '../cookie/CookieConsentBanner';
import {CookieConsentProvider} from '../../context/CookieConsentContext';
import {TemplateInfoContext, TemplateInfoContextType, TemplateInfoEnum} from '../../context/TemplateInfoContext';

config.autoAddCss = false;

type Props = {
  hideNavigations?: boolean;
  hideNavigationsKeepHeaderWithLogo?: boolean;
  showTopBanner?: boolean;
  bannerText?: string;
  currentPathname: string;
  slugLocales: SlugLocale[];
  categories?: ExtendedBlogCategories;
  templateInfo?: TemplateInfoContextType;
};

export const Layout: React.FC<PropsWithChildren<Props>> = ({hideNavigations = false, hideNavigationsKeepHeaderWithLogo = false, ...props}) => {
  const showHeaderWithoutNavigationButWithLogo = hideNavigationsKeepHeaderWithLogo && !hideNavigations;
  const showHeaderWithNavigationAndLogo = !hideNavigationsKeepHeaderWithLogo && !hideNavigations;
  const showFooter = !hideNavigations && !hideNavigationsKeepHeaderWithLogo;
  const templateInfo = {
    [TemplateInfoEnum.ORIGINAL_ID]: props.templateInfo?.originalId || '',
    [TemplateInfoEnum.MODEL_NAME]: props.templateInfo?.modelName || '',
    [TemplateInfoEnum.MODEL_ORIGINAL_ID]: props.templateInfo?.modelOriginalId || '',
    [TemplateInfoEnum.SLUG]: props.templateInfo?.slug || ''
  };

  return (
    <CookieConsentProvider>
      <TemplateInfoContext.Provider value={templateInfo}>
        <ParallaxProvider>
          <Container currentPathname={props.currentPathname}>
            {showHeaderWithoutNavigationButWithLogo && (
              <HeaderWithoutNavigation
                topBanner={{
                  text: props.bannerText,
                  isVisible: props.showTopBanner
                }}
              />
            )}
            {showHeaderWithNavigationAndLogo && (
              <Header
                currentPathname={props.currentPathname}
                categories={props.categories}
                topBanner={{
                  isVisible: props.showTopBanner
                }}
              />
            )}
            {props.children}
            {showFooter && <Footer slugLocales={props.slugLocales} />}
          </Container>
        </ParallaxProvider>
        <CookieConsentBanner />
      </TemplateInfoContext.Provider>
    </CookieConsentProvider>
  );
};
